export const userConstants = {
	UserGetByFilterRequest: "USER_GET_BYFILTER_STARTED",
	UserGetByFilterSuccess: "USER_GET_BYFILTER_COMPLETED",
	UserGetByFilterFailure: "USER_GET_BYFILTER_FAILED",

	UserRoleGetByFilterRequest: "USER_GET_ROLE_STARTED",
	UserRoleGetByFilterSuccess: "USER_GET_ROLE_COMPLETED",
	UserRoleGetByFilterFailure: "USER_GET_ROLE_FAILED",

	UserGetDetailRequest: "USER_GET_DETAIL_STARTED",
	UserGetDetailSuccess: "USER_GET_DETAIL_COMPLETED",
	UserGetDetailFailure: "USER_GET_DETAIL_FAILED",

	UserSaveRequest: "USER_SAVE_STARTED",
	UserSaveSuccess: "USER_SAVE_COMPLETED",
	UserSaveFailure: "USER_SAVE_FAILED",

	UserDeleteRequest: "USER_DELETE_STARTED",
	UserDeleteSuccess: "USER_DELETE_COMPLETED",
	UserDeleteFailure: "USER_DELETE_FAILED",

	UserGetCountByYearRequest: "USER_GET_COUNTBYYEAR_STARTED",
	UserGetCountByYearSuccess: "USER_GET_COUNTBYYEAR_COMPLETED",
	UserGetCountByYearFailure: "USER_GET_COUNTBYYEAR_FAILED",

	UserSaveAddressRequest: "USER_ADD_ADDRESS_STARTED",
	UserSaveAddressSuccess: "USER_ADD_ADDRESS_COMPLETED",
	UserSaveAddressFailure: "USER_ADD_ADDRESS_FAILED",

	UserGetAddressRequest: "USER_GET_ADDRESS_STARTED",
	UserGetAddressSuccess: "USER_GET_ADDRESS_COMPLETED",
	UserGetAddressFailure: "USER_GET_ADDRESS_FAILED",


	UserSaveCommunityRequest: "USER_SAVE_COMMUNITY_STARTED",
	UserSaveCommunitySuccess: "USER_SAVE_COMMUNITY_COMPLETED",
	UserSaveCommunityFailure: "USER_SAVE_COMMUNITY_FAILED",

	UserUpdateActiveStatusRequest: "USER_UPDATE_ACTIVESTATUS_STARTED",
	UserUpdateActiveStatusSuccess: "USER_UPDATE_ACTIVESTATUS_COMPLETED",
	UserUpdateActiveStatusFailure: "USER_UPDATE_ACTIVESTATUS_FAILED",

	UserGetPaymentRequest: "USER_GET_PAYMENT_STARTED",
	UserGetPaymentSuccess: "USER_GET_PAYMENT_COMPLETED",
	UserGetPaymentFailure: "USER_GET_PAYMENT_FAILED",

	UserRoleSaveRequest: "USER_SAVE_ROLE_STARTED",
	UserRoleSaveSuccess: "USER_SAVE_ROLE_COMPLETED",
	UserRoleSaveFailure: "USER_SAVE_ROLE_FAILED",

	UserRoleGetRequest: "USER_GET_BYROLE_STARTED",
	UserRoleGetSuccess: "USER_GET_BYROLE_COMPLETED",
	UserRoleGetFailure: "USER_GET_BYROLE_FAILED",

	userAccountUpdateRequest: "USER_ACCOUNT_UPDATE_STARTED",
	userAccountUpdateSuccess: "USER_ACCOUNT_UPDATE_COMPLETED",
	userAccountUpdateFailure: "USER_ACCOUNT_UPDATE_FAILED",

	userGetShopifyAddressRequest: "USER_GET_SHOPIFY_ADDRESS_STARTED",
	userGetShopifyAddressSuccess: "USER_GET_SHOPIFY_ADDRESS_COMPLETED",
	userGetShopifyAddressFailure: "USER_GET_SHOPIFY_ADDRESS_FAILED",
}